import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ProfileInfo } from './profile-info.model';
import { map } from 'rxjs/operators';

@Injectable()
export class ProfileService {

    private profileInfoUrl = '/api/profile-info';

    constructor(private http: HttpClient) { }

    getProfileInfo(): Observable<ProfileInfo> {
        return this.http.get<ProfileInfo>(this.profileInfoUrl).pipe(map((data: ProfileInfo) => {
            return {
                activeProfiles: data.activeProfiles,
                ribbonEnv: data.ribbonEnv,
                inProduction: data.activeProfiles.indexOf('prod') !== -1,
                swaggerEnabled: data.activeProfiles.indexOf('swagger') !== -1
            };
        }));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/profiles/profile.service.ts